/* tslint:disable */
/* eslint-disable */
/**
 * Změňte.to Admin API
 * Změňte.to Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SurveyEmailAttachmentDTO
 */
export interface SurveyEmailAttachmentDTO {
    /**
     * 
     * @type {string}
     * @memberof SurveyEmailAttachmentDTO
     */
    path: string;
    /**
     * 
     * @type {string}
     * @memberof SurveyEmailAttachmentDTO
     */
    filename: string;
}

export function SurveyEmailAttachmentDTOFromJSON(json: any): SurveyEmailAttachmentDTO {
    return SurveyEmailAttachmentDTOFromJSONTyped(json, false);
}

export function SurveyEmailAttachmentDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): SurveyEmailAttachmentDTO {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'path': json['path'],
        'filename': json['filename'],
    };
}

export function SurveyEmailAttachmentDTOToJSON(value?: SurveyEmailAttachmentDTO | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'path': value.path,
        'filename': value.filename,
    };
}

